import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {LayoutComponent} from './layout/layout.component';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {MenuComponent} from './menu/menu.component';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {TabService} from './tabconfig/tab.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {ToastrModule} from 'ngx-toastr';
import {ApiModule} from './api/api.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {NgbModule, NgbPopover, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import { MatConfirmDialogComponent } from './common/mat-confirm-dialog/mat-confirm-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatButton, MatButtonModule} from '@angular/material/button';

import {MatCalendar, MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';

import {NgxSpinner} from 'ngx-spinner/lib/ngx-spinner.enum';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AuthModule} from './system/auth.module';
import {AuthGuard} from './system/auth.guard';


//Mantenimiento
import { CoursesAddComponent } from './modules/maintenance/courses/courses-add/courses-add.component';
import { CoursesListComponent } from './modules/maintenance/courses/courses-list/courses-list.component';

import { EmployeeAddComponent } from './modules/maintenance/employee/employee-add/employee-add.component';
import { EmployeeListComponent } from './modules/maintenance/employee/employee-list/employee-list.component';

import { ModulesAddComponent } from './modules/maintenance/modules/modules-add/modules-add.component';
import { ModulesListComponent } from './modules/maintenance/modules/modules-list/modules-list.component';

import { QuestionsAddComponent } from './modules/maintenance/questions/questions-add/questions-add.component';
import { QuestionsListComponent } from './modules/maintenance/questions/questions-list/questions-list.component';

import { StudentsAddComponent } from './modules/maintenance/students/students-add/students-add.component';
import { StudentsListComponent } from './modules/maintenance/students/students-list/students-list.component';

//Seguridad
import { SystemuserListComponent } from './modules/security/systemuser/systemuser-list/systemuser-list.component';
import { LogListComponent } from './modules/security/log/log-list/log-list.component';
import { AuditListComponent } from './modules/security/audit/audit-list/audit-list.component';
import { AuditAddComponent } from './modules/security/audit/audit-add/audit-add.component';

//Configuracion
import { ParametersListComponent } from './modules/configuration/paramters/parameters-list/parameters-list.component';

//Home
import { HomeComponent } from './modules/home/home.component';

import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatStepperModule } from '@angular/material/stepper';

import { FileSelectDirective, FileDropDirective, FileUploadModule } from 'ng2-file-upload';
import { MoviesComponent } from './modules/maintenance/movies/movies.component';
import { OptionsComponent } from './modules/maintenance/options/options.component';

import { BlockUIModule } from 'ng-block-ui';
import { AssignStudentCourseComponent } from './modules/maintenance/assign-student-course/assign-student-course.component';
import { ParametersComponent } from './modules/configuration/parameters/parameters.component';
import { AssignFilesCourseComponent } from './modules/maintenance/assign-files-course/assign-files-course.component';
import { FileViewerComponent } from './modules/common/file-viewer/file-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import {MatRadioModule} from '@angular/material/radio';
import { StudentCourseComponent } from './modules/maintenance/student-course/student-course.component';
import { StudentCourseTaskComponent } from './modules/maintenance/student-course-task/student-course-task.component';
import { ChangeStatusComponent } from './modules/maintenance/courses/change-status/change-status.component';
import { ChatComponent } from './modules/maintenance/courses/chat/chat.component';
import { MovieViewerVimeoComponent } from './modules/common/movie-viewer-vimeo/movie-viewer-vimeo.component'

import {AutocompleteLibModule} from 'angular-ng-autocomplete';

import { EmployeeQuizComponent } from './modules/maintenance/employee/employee-quiz/employee-quiz.component';
import { CoursesQuizComponent } from './modules/maintenance/courses/courses-quiz/courses-quiz.component';
import { CoursesQuizTitleComponent } from './modules/maintenance/courses/courses-quiz-title/courses-quiz-title.component';
import { CoursesQuizCreateComponent } from './modules/maintenance/courses/courses-quiz-create/courses-quiz-create.component';
import { CoursesQuizCreateHeaderComponent } from './modules/maintenance/courses/courses-quiz-create-header/courses-quiz-create-header.component';
import { CoursesQuizCreateBodyComponent } from './modules/maintenance/courses/courses-quiz-create-body/courses-quiz-create-body.component';
import { CoursesQuizCreateQuestionComponent } from './modules/maintenance/courses/courses-quiz-create-question/courses-quiz-create-question.component';

import {MatCheckboxModule} from '@angular/material/checkbox';
import { CoursesQuizTitleAssignComponent } from './modules/maintenance/courses/courses-quiz-title-assign/courses-quiz-title-assign.component';

import { HttpClient } from '@angular/common/http';

const appRoutes: Routes = [
  {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), component: LayoutComponent, canActivate: [AuthGuard]},
  {path: '**', redirectTo: 'login', pathMatch: 'full'},
  {path: 'assign', component: AssignStudentCourseComponent},

];



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LayoutComponent,
    MenuComponent,
    MatConfirmDialogComponent,

    StudentsListComponent,
    StudentsAddComponent,
    EmployeeListComponent,
    EmployeeAddComponent,
    CoursesListComponent,
    CoursesAddComponent,
    ModulesListComponent,
    ModulesAddComponent,
    QuestionsListComponent,
    QuestionsAddComponent,
    SystemuserListComponent,
    LogListComponent,
    AuditListComponent,
    AuditAddComponent,
    ParametersListComponent,
    HomeComponent,
    MoviesComponent,
    OptionsComponent,
    AssignStudentCourseComponent,
    ParametersComponent,
    AssignFilesCourseComponent,
    FileViewerComponent,
    StudentCourseComponent,
    StudentCourseTaskComponent,
    ChangeStatusComponent,
    ChatComponent,
    MovieViewerVimeoComponent,

    EmployeeQuizComponent,
    CoursesQuizComponent,
    CoursesQuizTitleComponent,
    CoursesQuizCreateComponent,
    CoursesQuizCreateHeaderComponent,
    CoursesQuizCreateBodyComponent,
    CoursesQuizCreateQuestionComponent,
    CoursesQuizTitleAssignComponent
  ],
  imports: [
    AutocompleteLibModule,
    AuthModule,
    RouterModule.forRoot(appRoutes, {useHash: true}),
    ApiModule,
    BrowserModule,
    NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatRadioModule,
    MatCheckboxModule,

    NgxDocViewerModule,

    NgbModule,
    NgbPopoverModule,
    NgxMaterialTimepickerModule,
    NgxSpinnerModule,
    BrowserAnimationsModule, // required animations module
    MatStepperModule,
    AngularEditorModule,
    FileUploadModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 8000,
      positionClass: 'toast-top-right',
      enableHtml: true,
      progressBar: true,
      preventDuplicates: true,
    }) // ToastrModule added,

  ],
  providers: [
    TabService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
  ],
  bootstrap: [AppComponent],
  entryComponents:[
    MatConfirmDialogComponent
  ]
})
export class AppModule { }
